import { useCallback, useContext, useMemo, useState } from "react";
import { LocaleContext } from "../store/providers/LocaleProvider";

export const useLocalizedCountries = () => {
    const [localeState] = useContext(LocaleContext);
    
    const [countries, setCountries] = useState();
    const [initialized, setInitialized] = useState(false);
    
    const locale = localeState.localeUppercaseUnderscore.indexOf("en") === 0 
        ? "en" 
        : localeState.localeUppercaseUnderscore;

    import("../common/i18n/countries/country_" + locale).then(res => {
        const countries = res?.COUNTRY;
        setCountries(countries);
        setInitialized(true);
    });

    const getCountryByCountryCode = useCallback((countryCode) => {
        if (initialized && countries) {
            return countries[countryCode];
        }
    }, [initialized, countries]);

    const value = useMemo(() => ({
        initialized,
        countries,
        getCountryByCountryCode
    }), [initialized, countries, getCountryByCountryCode]);

    return value;
};